import styled, { css } from 'styled-components';
import { colors, layout } from '@prisjakt/ui-base';
import SearchMDI from 'mdi-react/SearchIcon';
import HeartIcon from 'mdi-react/HeartOutlineIcon';

const padding = layout.spacing.xSmall;

const sharedInfoStyling = css`
  width: 100%;
  max-width: 100%;
  flex-direction: column;
  overflow: hidden;
`;

export const ItemRow = styled.div`
  display: flex;
  align-items: center;
  padding: ${padding};
  text-align: left;
  width: 100%;
  cursor: pointer;
`;

type IconProps = { border?: boolean };
export const Icon = styled.div<IconProps>`
  margin-right: ${padding};
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  background: ${p => (p.border ? p.theme.bg.secondary : 'transparent')};
  padding: ${p => (p.border ? `${padding}` : 0)};
  border-radius: ${p => (p.border ? '50%' : 0)};
`;

export const SearchIcon = styled(SearchMDI).attrs(p => ({
  color: p.theme.icons.secondary,
}))``;

export const Image = styled.img`
  max-width: 40px;
  max-height: 40px;
  mix-blend-mode: multiply;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  ${sharedInfoStyling};
`;

export const PlaceholderInfo = styled.div`
  ${sharedInfoStyling};
`;

type NameProps = { bold?: boolean; truncate?: boolean };
export const Name = styled.p<NameProps>`
  margin-bottom: 2px;
  font-weight: ${p => (p.bold ? 'bold' : 'normal')};
  color: ${p => p.theme.text.primary};

  ${p =>
    // Truncate list name if its too long
    p.truncate &&
    css`
      max-width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    `};
`;

export const Count = styled.p`
  color: ${colors.darkGray2};
  font-size: ${layout.fontSizes.small.desktop.rem};
  margin: 0;
`;

export const MoreMenu = styled.div`
  position: absolute;
  right: ${padding};
  top: ${padding};
`;

export const PlaceHolderLineOfText = styled.div`
  background: ${colors.lightGray2};
  border-radius: 1px;
  height: 1em;
  opacity: 0.25;
  :not(:first-child) {
    margin-top: ${layout.spacing.xSmall};
  }
`;

export const PlaceHolderPriceChange = styled(PlaceHolderLineOfText)<{
  isPositive: boolean;
}>`
  background: ${({ isPositive }) => (isPositive ? colors.green1 : colors.red1)};
  float: right;
`;

export const CreateListIcon = styled(HeartIcon).attrs(p => ({
  color: p.theme.icons.quaternary,
}))``;
